<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Users</h4>
          </div>
          <div class="col-6 text-right">
            <appModalUserNew></appModalUserNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Dealer</label>
            <select
              v-model="dealerId"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All</option>
              <option
                :value="dealer.id"
                v-for="dealer in getDealerDropdown"
                :key="dealer.id"
              >
                {{ dealer.name }}
              </option>
            </select>
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Role</label>
            <select
              v-model="selectedRoleId"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All</option>
              <option value="1">Admin</option>
              <option value="2">VSA staff</option>
              <option value="3">BDM</option>
              <option value="4">Dealer staff</option>
              <option value="5">Referral partners</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableUserList">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item header-column-0">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-1">Title</th>
                <th class="header-item header-column-2">
                  <a href="#" @click.prevent="fnChangeSort('firstName')"
                    >First name</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'firstName'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'firstName'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-3">
                  <a href="#" @click.prevent="fnChangeSort('middleName')"
                    >Middle name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'middleName'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'middleName'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-4">
                  <a href="#" @click.prevent="fnChangeSort('lastName')"
                    >Last name</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'lastName'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'lastName'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-5">Role / Designation</th>
                <th class="header-item header-column-6">Dealer/s</th>
                <th class="header-item header-column-7">
                  <a href="#" @click.prevent="fnChangeSort('email')">E-mail</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'email'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'email'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-8">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-9">
                  <a href="#" @click.prevent="fnChangeSort('isVerified')"
                    >Verified</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'isVerified'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'isVerified'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-10">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in getAdminUserPaginateData.data" :key="row.id">
                <td class="column-0">{{ row.id }}</td>
                <td class="column-1">{{ row.title }}</td>
                <td class="column-2">
                  {{ row.firstName }}
                </td>
                <td class="column-3">{{ row.middleName }}</td>
                <td class="column-4">
                  {{ row.lastName }}
                </td>
                <td class="column-5">
                  <div>
                    {{ row.role }}
                  </div>
                  <div class="fs-600">{{ row.designationName }}</div>
                </td>
                <td class="column-6">
                  <WDExpandCell
                    :rowId="row.id"
                    :rows="row.dealers"
                    @fnSelectRow="fnSetActiveRow(row.id)"
                    @fnCloseExpand="fnCloseExpand"
                    :activeRow="activeRow"
                  ></WDExpandCell>
                </td>
                <td class="column-7">
                  {{ row.email }}
                </td>
                <td class="column-8">
                  <div v-if="row.status == 1">
                    <span class="badge bdg-active">Active</span>
                  </div>
                  <div v-if="row.status == 0">
                    <span class="badge bdg-in-active">In-active</span>
                  </div>
                </td>
                <td class="column-9">
                  <div v-if="row.isVerified == 1">
                    <span class="badge bdg-active">Verified</span>
                  </div>
                  <div v-if="row.isVerified == 0">
                    <span class="badge bdg-in-active">Non-verified</span>
                  </div>
                </td>
                <td class="column-10">
                  <div class="d-flex">
                    <appModalUserEdit
                      :userId="row.id"
                      class="d-inline"
                    ></appModalUserEdit>
                    <appModalResendActivationLink
                      :propsData="row"
                      class="d-inline"
                    ></appModalResendActivationLink>
                    <appSwitchUser
                      v-if="loginUserObj.role_id == 1"
                      :userId="row.id"
                      class="d-inline"
                    ></appSwitchUser>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="11">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getAdminUserPaginateData"
                        @pagination-change-page="fnGetList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
import appModalUserNew from '../../components/admin/user/ModalUserNew.vue'
import appModalUserEdit from '../../components/admin/user/ModalUserEdit.vue'
import appModalUserDelete from '../../components/admin/user/ModalUserDelete.vue'
import appModalResendActivationLink from '../../components/admin/user/ModalResendActivationLink.vue'
import appSwitchUser from '../../components/admin/user/SwitchUser.vue'
import WDExpandCell from '../../components/wd/WDExpandCell.vue'

export default {
  name: 'adminQuoteList',
  components: {
    pagination,
    appModalUserNew,
    appModalUserEdit,
    appModalUserDelete,
    appModalResendActivationLink,
    WDExpandCell,
    appSwitchUser
  },
  data() {
    return {
      isDataFetch: true,
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      dealerId: '',
      selectedRoleId: '',
      sort_direction: 'desc',
      sort_field: 'id',
      quoteCalculation: {},
      paginate: {
        dealerUserId: '',
        dealerId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        role_id: '',
        sort_direction: 'desc',
        sort_field: 'id'
      },
      loginUserObj: {},
      activeRow: -1
    }
  },
  computed: {
    ...mapGetters(['getAdminUserPaginateData', 'getDealerDropdown'])
  },
  methods: {
    ...mapActions(['fetchAdminUserPaginateData', 'fetchDealerDropdown']),

    fnGetList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        dealerId: this.dealerId,
        role_id: this.selectedRoleId,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminUserPaginateData(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        dealerId: this.dealerId,
        role_id: this.selectedRoleId,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchAdminUserPaginateData(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        dealerId: this.dealerId,
        role_id: this.selectedRoleId,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminUserPaginateData(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        dealerId: this.dealerId,
        role_id: this.selectedRoleId,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminUserPaginateData(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedRoleId = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        role_id: '',
        dealerId: '',
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminUserPaginateData(objNew)
    },
    fnSetActiveRow(rowId) {
      this.activeRow = rowId
      return
    },
    fnCloseExpand() {
      this.activeRow = -1
      return
    }
  },
  async mounted() {
    this.isDataFetch = true
    this.loginUserObj = authService.getUserFromToken()
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      role_id: '',
      dealerId: '',
      sort_direction: this.sort_direction,
      sort_field: this.sort_field
    }
    let objNew = { ...obj1, ...obj2 }
    this.fetchAdminUserPaginateData(objNew)
    this.fetchDealerDropdown()
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
